import React from "react";
import "./css/Header.css"; // import CSS
import GIMALogo from "./images/gima_logo.jpeg";   // GIMA logo

function Header() {
  return (

      <header className="header">
      {/* Row 1: Logos + Title */}
      <div className="header-top">
        <img src={GIMALogo} alt="GIMA Logo" className="header-logo" />
        <h1 className="header-title">Gothenburg Indian Muslims Association  (GIMA)</h1>
        <img src={GIMALogo} alt="GIMA Logo" className="header-logo" />
      </div>

      {/* Row 2: Navigation links */}
      {/*
      <nav className="header-nav">
        <a href="/">Home</a>
        <a href="/contact">Contact</a>
      </nav>
    */}
    </header>
   
  );
}
export default Header;
